import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingJpgToPngConfig } from '@/data/landingConfig/landingJpgToPngConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_JpgToPng } from './schemaObject';

interface Props {}
const JpgToPngConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_JpgToPng} />
			<LandingTemplate
				data={landingJpgToPngConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default JpgToPngConverter;
